/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyRefDto } from './companyRefDto';


export interface ApproveUserDto { 
    overridePassword?: string;
    position?: string;
    agency: CompanyRefDto;
    groups: Array<string>;
    teams: Array<string>;
    sso?: boolean;
    expiryDate?: string;
    firstName: string;
    lastName: string;
    email: string;
}

